export default __webpack_public_path__ + "static/RunLeft5-e8b5f910bb4274758664335be8a0b17d.mp3";